(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cool-sculpting-faq"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cool-sculpting-gallery"]) return;
  try {
    
  var thumbnails = new Splide( '#thumbnails', {
      rewind      : true,
      fixedWidth  : 100,
      fixedHeight : 64,
      isNavigation: true,
      gap         : 10,
      focus       : 'center',
      pagination  : false,
      cover       : true,
      breakpoints : {
          '600': {
              fixedWidth  : 66,
              fixedHeight : 40,
          }
      }
  } ).mount();

  // Create the main slider.
  var mainSlider = new Splide( '#main-gallery', {
      type       : 'fade',
      heightRatio: 0.5,
      pagination : false,
      arrows     : false,
      cover      : true,
  } );

  // Set the thumbnails slider as a sync target and then call mount.
  mainSlider.sync( thumbnails ).mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["day-spa-faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-gallery"]) return;
  try {
    
  var thumbnails = new Splide( '#thumbnails', {
      rewind      : true,
      fixedWidth  : 100,
      fixedHeight : 64,
      isNavigation: true,
      gap         : 10,
      focus       : 'center',
      pagination  : false,
      cover       : true,
      breakpoints : {
          '600': {
              fixedWidth  : 66,
              fixedHeight : 40,
          }
      }
  } ).mount();

  // Create the main slider.
  var mainSlider = new Splide( '#main-gallery', {
      type       : 'fade',
      heightRatio: 0.5,
      pagination : false,
      arrows     : false,
      cover      : true,
  } );

  // Set the thumbnails slider as a sync target and then call mount.
  mainSlider.sync( thumbnails ).mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medspa-faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nail-salon-faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-faq-tabs"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-faq"]) return;
  try {
    
var acc = document.getElementsByClassName("accordian-header");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
    	this.classList.toggle("active");
        var panel = this.nextElementSibling; 
        if (panel.style.maxHeight) {
        	panel.style.maxHeight = null;
        } else {             
        	panel.style.maxHeight = panel.scrollHeight + "px";                 
        }
    }); 
}

  } catch(e) { console.error(e); }
})();
})();
